import axios from "axios";

const prepareData = (data) => {return {project_drawing_office_ifa:data}}

// Plural Actions
export const GET_PROJECT_DRAWING_OFFICE_IFAS = "get_project_drawing_office_ifas";
export const getProjectDrawingOfficeIfas = (project_id) => {
	const url = `/project/${project_id}/drawing_office/ifas.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_DRAWING_OFFICE_IFAS,
		payload: request
	};
};


export const GET_PROJECT_DRAWING_OFFICE_IFAS_DRAWING_REGISTER = "get_project_drawing_office_ifas_drawing_register";
export const getProjectDrawingOfficeIfasDrawingRegister = (project_id) => {
	const url = `/project/${project_id}/drawing_office/ifas/drawing_register.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_DRAWING_OFFICE_IFAS_DRAWING_REGISTER,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_DRAWING_OFFICE_IFA = "create_project_drawing_office_ifa";
export const createProjectDrawingOfficeIfa = (project_id,data) => {
	const url = `/project/${project_id}/drawing_office/ifas.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_DRAWING_OFFICE_IFA,
		payload: request
	};
};

export const GET_PROJECT_DRAWING_OFFICE_IFA = "get_project_drawing_office_ifa";
export const getProjectDrawingOfficeIfa = (project_id,id) => {
	const url = `/project/${project_id}/drawing_office/ifas/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_DRAWING_OFFICE_IFA,
		payload: request
	};
};

export const UPDATE_PROJECT_DRAWING_OFFICE_IFA = "update_project_drawing_office_ifa";
export const updateProjectDrawingOfficeIfa = (project_id,id,data) => {
	const url = `/project/${project_id}/drawing_office/ifas/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_DRAWING_OFFICE_IFA,
		payload: request
	};
};

export const DESTROY_PROJECT_DRAWING_OFFICE_IFA = "destroy_project_drawing_office_ifa";
export const destroyProjectDrawingOfficeIfa = (project_id,id) => {
	const url = `/project/${project_id}/drawing_office/ifas/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_DRAWING_OFFICE_IFA,
		payload: request
	};
};
